const { PlaceTypeKeyEnum } = require('@aviv_price-pages/brand');

const levelByPlaceTypeKey = new Map()
    .set(PlaceTypeKeyEnum.COUNTRY, 10)
    .set(PlaceTypeKeyEnum.MACROREGION, 20)
    .set(PlaceTypeKeyEnum.REGION, 30)
    .set(PlaceTypeKeyEnum.MICROREGION, 40)
    .set(PlaceTypeKeyEnum.PROVINCE, 50)
    .set(PlaceTypeKeyEnum.COUNTY, 60)
    .set(PlaceTypeKeyEnum.MUNICIPALITY, 70)
    .set(PlaceTypeKeyEnum.BOROUGH, 80)
    .set(PlaceTypeKeyEnum.MACRO_NEIGHBORHOOD, 90)
    .set(PlaceTypeKeyEnum.NEIGHBORHOOD, 100)
    .set(PlaceTypeKeyEnum.MICRO_NEIGHBORHOOD, 110)
    .set(PlaceTypeKeyEnum.STATISTICAL_UNIT, 120)
    .set(PlaceTypeKeyEnum.MICRO_STAT_UNIT, 130)
    .set(PlaceTypeKeyEnum.BLOCK, 140)
    .set(PlaceTypeKeyEnum.STREET, 160)
    .set(PlaceTypeKeyEnum.PARCEL, 170)
    .set(PlaceTypeKeyEnum.HOUSE_NUMBER, 180)
    .set(PlaceTypeKeyEnum.BUILDING, 190);

function level(placeType) {
    return levelByPlaceTypeKey.get(placeType) || 0;
}

function activePlaceTypes({ geoConfig }) {
    return Object.entries(geoConfig)
        .filter(([, { active }]) => !!active)
        .map(([placeType]) => placeType);
}

module.exports = {
    level,
    activePlaceTypes,
};
